import { render } from "./Footer.vue?vue&type=template&id=09893b51&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=09893b51&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09893b51"]])

export default __exports__